<div class="modal-content" >
  <div class="modal-header">
    <h4 style="max-width: 80% !important;"><strong> {{ modalDetails?.optInModalTitle }} </strong></h4>
  </div>
  <div class="modal-body our-form-background">
    <div class="container-fluid">
      <p-card >
        <ng-template pTemplate="header" *ngIf="modalDetails?.optInModalText" >
          <div [innerHTML]="modalDetails?.optInModalText"></div>
        </ng-template>
        <div class="row" >
          <div class="col-12">
            <app-agree-contract [company]="company"></app-agree-contract>
          </div>
        </div>
      </p-card>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button"  pButton
            class="relative waves-light eca-btn eca-btn-primary"
            (click)="signOut()"
            >
      <span >Log Out</span>  <fa-icon style="margin-left: 10px" [icon]="'sign-out'" size="lg" ></fa-icon>
    </button>
    <button type="button"  pButton
            class="relative waves-light eca-btn eca-btn-primary"
            (click)="agreeContract()"
            >
      <span >{{modalDetails?.continueButtonText}}</span>  <fa-icon style="margin-left: 10px" [icon]="'arrow-right'" size="lg" ></fa-icon>
    </button>
  </div>
</div>
